import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logos/logo3.png'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "content d-flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "login-form" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body p-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-3 mx-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    border: "0",
    alt: "",
    class: "img-fluid"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-center mb-3" }, " Bitte geben Sie den Bestätigungspin ein. ", -1)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", {
                class: _normalizeClass(["col-form-label", {'text-danger':_ctx.frm.pin.error}])
              }, "Pin", 2),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", {'is-invalid':_ctx.frm.pin.error}]),
                type: "password",
                tabindex: "2",
                placeholder: "*****",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frm.pin.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.frm.pin.value]
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.frm.pin.error), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-lg btn-block",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmImpersonate && _ctx.confirmImpersonate(...args))),
                tabindex: "3"
              }, "Bestätigen")
            ])
          ])
        ])
      ])
    ])
  ]))
}